import { render, staticRenderFns } from "./ClinicDialog.vue?vue&type=template&id=55b75835&scoped=true"
import script from "./ClinicDialog.vue?vue&type=script&lang=js"
export * from "./ClinicDialog.vue?vue&type=script&lang=js"
import style0 from "./ClinicDialog.vue?vue&type=style&index=0&id=55b75835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b75835",
  null
  
)

export default component.exports